import * as React from "react";
import IRepertoireComponentDataItem from "../../../../redux/types/IRepertoireComponentDataItem";
import { ITabReduxItem } from "../../../../redux/types/ITabReduxItem";
import { addTab, updateUsagePoolField } from "../../../../redux/reducers/RepertoireReducer";
import { ADD_NEW_ACTION, CHECKBOX_INPUT, DATES_AND_DIMENSIONS, POOL_ALLOCATION_SETTINGS_KEY, POOL_AMOUNT_MULTIPLIER_ENABLED_STATE_KEY, POOL_AMOUNT_MULTIPLIERS_KEY, POOL_ENABLED_STATE_KEY, POOL_ESTIMATED_VALUE_PER_POINT_SETTINGS_KEY, POOL_EVPP_ENABLED_STATE_KEY, POOL_RIGHT_TYPES_KEY, POOL_SOURCES_KEY, POOL_WEIGHT_SETTING_CODE_STATE_KEY, SELECTED_DATE_RANGE_ID_STATE_KEY, POOL_WEIGHT_SETTING_CODES_KEY, POOL_WEIGHT_SETTINGS_KEY, REMOVE_ACTION, TEXT_INPUT, POOL_WEIGHT_CODE_MULTIPLIER_STATE_KEY, MULTI_SELECT_DROPDOWN } from "../../../Consts";
import DataGridTable from "../../../components/dataGridTable/DataGridTable";
import { IRepertoireStateKeys } from "../../../types/IRepertoireStateKeys";
import { IRepertoireField } from "../../../types/IRepertoireField";
import { ILookupDictionary } from "../../../../lookup/types/ILookupDictionary";
import { IUsagePoolState, IUsagePoolStateKeys } from "../../../../redux/types/IUsagePoolState";
import { IUsagePoolSourceDataItems } from "../../../types/usageTypes/IUsagePoolSourceDataItems";
import { ITreeData } from "../../../types/ITreeData";
import { IUsagePoolRightTypeDataItem } from "../../../types/usageTypes/IUsagePoolRightTypeDataItem";
import { IUsagePoolAllocationSettingsDataItems } from "../../../types/usageTypes/IUsagePoolAllocationSettingsDataItems";
import PoolMaintenanceAllocationSettingsGrid from "../poolMaintenanceAllocationSettingsGrid/PoolMaintenanceAllocationSettingsGrid";
import DatesAndDimensionsWeightingTable from "./DatesAndDimensionsWeightingTable";
import { IUsageWeightSettingsDataItems } from "../../../types/usageTypes/IUsageWeightSettingsDataItems";
import PoolMaintenanceWeightSettingsGrid from "../poolMaintenanceWeightSettingsGrid/PoolMaintenanceWeightSettingsGrid";
import { IUsagePoolDatesAndDimensions } from "../../../types/usageTypes/IUsagePoolDatesAndDimensions";
import { SizedCheckboxDataInput } from "../../../components/checkboxDataInput/CheckboxDataInput";
import { IUsageEVPPSettingsDataItems } from "../../../types/usageTypes/IUsageEVPPSettingsDataItems";
import PoolMaintenanceEstimatedValuePerPointSettingsGrid from "../poolMaintenanceEstimatedValuePerPointSettingsGrid/poolMaintenanceEstimatedValuePerPointSettingsGrid";
import { IUsageAmountMultiplierDataItem } from "../../../types/usageTypes/IUsageAmountMultiplierDataItem";
import { If } from "../../../../core/components/If";
import SaveResult from "../../../components/saveResult/SaveResult";
import { IValidationMessage } from "../../../types/IValidationMessage";
import PoolMaintenanceWeightSettingCodesGrid from "../poolMaintenanceWeightSettingCodesGrid/PoolMaintenanceWeightSettingCodesGrid";
import PoolWeightCodeMultiplierGrid from "../poolMaintenanceWeightSettingCodesGrid/PoolWeightCodeMultiplierGrid";
import { IUsagePoolWeightSettingCodesDataItems } from "../../../types/usageTypes/IUsageWeightSettingCodesDataItems";
import { IUsagePoolWeightCodeMultiplierDataItems } from "../../../types/usageTypes/IUsagePoolWeightCodeMultiplierDataItems";
import { IResultsPerPage } from "../../../../redux/types/IResultsPerPage";
import { IActiveAccordion } from "../../../../redux/types/IActiveAccordion";

export interface IUsagePoolMaintenanceGridsViewProps {
    weightSettingsPoolMaintenance: IRepertoireComponentDataItem;
    usagePoolMaintenanceGridsViewData: IRepertoireComponentDataItem;
    usagePoolMaintenanceAllocationSettingsGridViewData: IRepertoireComponentDataItem;
    usagePoolMaintenanceWeightSettingsGridViewData: IRepertoireComponentDataItem;
    usagePoolMaintenanceWeightSettingCodesGridViewData: IRepertoireComponentDataItem;
    usagePoolMaintenanceEstimatedValuePerPointSettingsGridViewData: IRepertoireComponentDataItem;
    dataGridTableData?: IRepertoireComponentDataItem;
    componentInstance: string;
    usagePoolSources: IUsagePoolSourceDataItems[];
    weightSettings: IUsageWeightSettingsDataItems[];
	weightSettingCodes?: IUsagePoolWeightSettingCodesDataItems[];
	weightCodeMultiplier?: IUsagePoolWeightCodeMultiplierDataItems[];
    amountMultipliers: IUsageAmountMultiplierDataItem[];
    poolEVPPSettings: IUsageEVPPSettingsDataItems[];
    addTab: typeof addTab;
    tabs: ITabReduxItem[];
    activeTab: number;
    lookupValues: ILookupDictionary;
    updateUsagePoolField: typeof updateUsagePoolField;
    lookupSources: ITreeData[];
    isReadonly: boolean;
    rightTypes?: IUsagePoolRightTypeDataItem[];
    allocationSettings?: IUsagePoolAllocationSettingsDataItems;
    poolID?: number;
    incrementTempID?: () => void;
    poolEnabled?: boolean;
    weightSettingsIsEnabled?: boolean;
    amountMultipliersIsEnabled?: boolean;
    evppSettingsIsEnabled?: boolean;
    datesAndDimensions?: IUsagePoolDatesAndDimensions[];
    saveChanges: () => void;
    sortWeightSettingsFieldData;
    isBulkCheckboxActive?: boolean;
    changeBulkCheckbox?: (value: boolean) => void;
    exportUsagePoolWeightMultiplier: (poolDimensionsAndDatesID: number) => void;
    importUsagePoolWeightMultiplier: (poolDimensionsAndDatesID: number) => void;
    exportWeightSettingCodes: (poolDimensionsAndDatesID: number) => void;
    importWeightSettingCodes: (poolDimensionsAndDatesID: number) => void;
    saveResultData: IRepertoireComponentDataItem;
    resetMessageBanner?: () => void;
    allResultsPerPage?: IResultsPerPage[];
    updateUserPreferences?: (allResultsPerPage: IResultsPerPage[], activeAccordions: IActiveAccordion[], newActiveAccordionName?: string, accordionExpanded?: boolean, componentName?: string, indexOfFirstResult?: number, indexOfLastResult?: number, resultsPerPage?: number, repertoireSection?: string) => void;
}

interface IusagePoolMaintenanceGridsViewState {
    activeHeaderSection: string;
    loaded: boolean;
	selectedDimensionAndDateRange?: IUsagePoolDatesAndDimensions;
}

export default class UsagePoolMaintenanceGridsView extends React.PureComponent<
    IUsagePoolMaintenanceGridsViewProps,
    IusagePoolMaintenanceGridsViewState
> {
    viewData;
    constructor(props: IUsagePoolMaintenanceGridsViewProps) {
        super(props);
        this.state = {
            activeHeaderSection: POOL_SOURCES_KEY,
            loaded: false
        }
        this.viewData = {};
    }

    componentDidUpdate() {
        this.loadData();
    }

    componentDidMount() {
        this.loadData();
    }


    loadData() {
        const { loaded } = this.state;
        if (!loaded) {
            if (!this.props.usagePoolMaintenanceGridsViewData) {
                return;
            }
            else {
                this.setState({ loaded: true });
            }
        }
    }


    onClickHeaderSection = (activeHeaderSection: string) => {
        this.setState({
            activeHeaderSection
        });
    };

    changeData = (value: any, name: IRepertoireStateKeys) => {
        const { lookupValues, updateUsagePoolField } = this.props;
        updateUsagePoolField(value, name as IUsagePoolStateKeys, lookupValues);
    }

    renderGridViewHeaderSections = () => {
        const { activeHeaderSection } = this.state;
        const { usagePoolMaintenanceGridsViewData } = this.props;

        if (usagePoolMaintenanceGridsViewData && usagePoolMaintenanceGridsViewData.fields) {
            return usagePoolMaintenanceGridsViewData.fields.filter(f => f.fieldType === null).map((section, index) => (
                <div
                    className={[
                        "headerSection",
                         activeHeaderSection === section.name ? "activeSection" : null
                    ].join(" ")}
                    key={index}
                    onClick={() => this.onClickHeaderSection(section.name)}
                >
                    {section.data}
                </div>
            ));
        }
    };

    handleDeleteAllLinkedWeightsSettingsWhenTheDatesAndDimensionsAreDeleted = (deletedDatesAndDimensionsRow: IUsagePoolDatesAndDimensions) => { 
        const { weightSettings, datesAndDimensions, weightSettingCodes, weightCodeMultiplier } = this.props;
        if (deletedDatesAndDimensionsRow.effectiveDateRange) {
			var hasLinkedSettings = false;
            if (weightSettings?.length > 0) {
                const weightSettingsRemaining = weightSettings.filter(weights => weights.effectiveDateRange.value !== deletedDatesAndDimensionsRow.effectiveDateRange);
                this.changeData(weightSettingsRemaining, POOL_WEIGHT_SETTINGS_KEY);
				hasLinkedSettings = true;
            }
			
			if (weightSettingCodes?.length > 0) {
				const weightSettingCodesRemaining = weightSettingCodes.filter(code => code.effectiveDateRange.value !== deletedDatesAndDimensionsRow.effectiveDateRange);
                this.changeData(weightSettingCodesRemaining, POOL_WEIGHT_SETTING_CODES_KEY);
				hasLinkedSettings = true;
            }
			
			if (weightCodeMultiplier?.length > 0) {
				const weightCodeMultiplierRemaining = weightCodeMultiplier.filter(weights => weights.effectiveDateRange.value !== deletedDatesAndDimensionsRow.effectiveDateRange);
				this.changeData(weightCodeMultiplierRemaining, POOL_WEIGHT_CODE_MULTIPLIER_STATE_KEY);
				hasLinkedSettings = true;
            }
			
			if (hasLinkedSettings) {
				const allRemainingDatesAndDimensions = datesAndDimensions.filter(dND => dND.effectiveDateRange !== deletedDatesAndDimensionsRow.effectiveDateRange);
				this.changeData(allRemainingDatesAndDimensions, DATES_AND_DIMENSIONS);
			}
        }
    }

	handleSelectedDimensionAndDateRange = (value) => {
		this.setState({ selectedDimensionAndDateRange: value })
	}

    render() {
        const {
            dataGridTableData,
            usagePoolSources,
            weightSettings,
			weightCodeMultiplier,
            weightSettingCodes,
            poolEVPPSettings,
            usagePoolMaintenanceGridsViewData,
            weightSettingsPoolMaintenance,
            usagePoolMaintenanceAllocationSettingsGridViewData,
            usagePoolMaintenanceWeightSettingsGridViewData,
            usagePoolMaintenanceWeightSettingCodesGridViewData,
            usagePoolMaintenanceEstimatedValuePerPointSettingsGridViewData,
            isReadonly,
            lookupValues,
            lookupSources,
            rightTypes,
            allocationSettings,
            activeTab,
            tabs,
            updateUsagePoolField,
            poolID,
            incrementTempID,
            poolEnabled,
            datesAndDimensions,
            saveChanges,
            weightSettingsIsEnabled,
            amountMultipliers,
            amountMultipliersIsEnabled,
            evppSettingsIsEnabled,
            sortWeightSettingsFieldData,
            isBulkCheckboxActive,
            changeBulkCheckbox,
            exportUsagePoolWeightMultiplier,
            importUsagePoolWeightMultiplier,
            saveResultData,
            resetMessageBanner,
            componentInstance,
            exportWeightSettingCodes,
            importWeightSettingCodes,
            allResultsPerPage,
            updateUserPreferences
        } = this.props;

        const {
            activeHeaderSection,
			selectedDimensionAndDateRange
        } = this.state;

        const filteredFields = usagePoolMaintenanceGridsViewData.fields.filter(
            (field: IRepertoireField) =>
                field.name === activeHeaderSection
        );

        const { loaded } = this.state;
        if (!loaded)
            return <div className="loading" />

        if (!allocationSettings) {
            const newAllocationSettings = {
                poolID: poolID !== undefined ? poolID : 0,
                poolAllocationSettingsID: 0,
                unidentifiedUsage: { value: false, inputType: CHECKBOX_INPUT },
                nonSocietyIPs: { value: false, inputType: CHECKBOX_INPUT },
                referenceIPs: { value: false, inputType: CHECKBOX_INPUT },
                missingShares: { value: false, inputType: CHECKBOX_INPUT },
                warsawRule: { value: false, inputType: CHECKBOX_INPUT },
                percentageDurationForUnidentifiedUsage: { value: false, inputType: CHECKBOX_INPUT },
                defaultDurationPercentage: { value: 0, inputType: TEXT_INPUT },
                reciprocalAgreements: { value: false, inputType: CHECKBOX_INPUT },
                pdWork100Percent: { value: false, inputType: CHECKBOX_INPUT },
                pdiPs: { value: false, inputType: CHECKBOX_INPUT },
                pdArrangementShareCalc: { value: false, inputType: CHECKBOX_INPUT },
                arrangersOOCShareCalc: { value: false, inputType: CHECKBOX_INPUT },
                allocateSpecificRoles: { value: [], inputType: MULTI_SELECT_DROPDOWN },
                allocateSpecificSocieties: { value: [], inputType: MULTI_SELECT_DROPDOWN },
                customNotebook: { value: '', inputType: TEXT_INPUT },
                deductCommissionPercentage: { value: null, inputType: TEXT_INPUT },
                excludeLibraryWorks: { value: false, inputType: TEXT_INPUT },
                rightTypeRedirect: { value: null, inputType: TEXT_INPUT },
                nonSocietyPublisherRedirect: { value: false, inputType: CHECKBOX_INPUT },
                useAdvertisementDurationForMatchedUsage: { value: false, inputType: CHECKBOX_INPUT },
                useCueSheetDurationForMatchedUsage: { value: false, inputType: CHECKBOX_INPUT },
                useWeightAsAmount: { value: false, inputType: CHECKBOX_INPUT },
                excludeProductWorks: { value: false, inputType: CHECKBOX_INPUT },
            }

            updateUsagePoolField(newAllocationSettings, POOL_ALLOCATION_SETTINGS_KEY);
        }

        let sections = [];
        let messages: IValidationMessage[];

        if(tabs[activeTab].validationMessages != null) {
            messages = [];
            tabs[activeTab].validationMessages.forEach(e => {
                if(saveResultData.fields.find(x => x.name.toString() === e.messageKey)?.section != null) {
                    sections.push(saveResultData.fields.find(x => x.name.toString() === e.messageKey)?.section);
                    let validationMessage: IValidationMessage = { messageKey: e.messageKey, additionalInfo: e.additionalInfo }
                    messages.push(validationMessage);
                }
            })
        }

        return (
            <>
                <div className="GridsView">
                    <div className="headerContainer">
                        {this.renderGridViewHeaderSections()}
                    </div>
                    <If condition={tabs[activeTab].validationMessages != null && 
                        tabs[activeTab].validationMessages.length > 0 && 
                        (sections.includes(activeHeaderSection))}>
                            <SaveResult
                                componentInstance={componentInstance}
                                saveSuccess={tabs[activeTab].saveSuccessful}
                                postSuccess={tabs[activeTab].postSuccessful}
                                matchingSuccess={tabs[activeTab].matchingSuccessful}
                                mergeSuccess={tabs[activeTab].mergeSuccessful}
                                exportSuccess={tabs[activeTab].exportSuccessful}
                                saveResultData={saveResultData}
                                messages={messages}
                                resetMessageBanner={resetMessageBanner}
                                deleteAccount={tabs[activeTab].deleteSuccessful}
                                newAllocateDistributionPoolsJobSuccess={tabs[activeTab].newAllocateDistributionPoolsJobSuccess}
                                newAllocateDistributionConfirmationShow={tabs[activeTab].newAllocateDistributionConfirmationShow}
                                allocationJobInProgress={false}                        
                            />
                    </If>
                    {activeHeaderSection === POOL_SOURCES_KEY && (
                        <DataGridTable
                            tableContents={usagePoolSources}
                            changeData={this.changeData.bind(this)}
                            dataGridTableData={dataGridTableData}
                            stateKey={filteredFields[0].name}
                            componentInstance={POOL_SOURCES_KEY}
                            showRowNumber={true}
                            isReadOnly={isReadonly}
                            tableActions={[{ name: ADD_NEW_ACTION }]}
                            lookupValues={lookupValues}
                            lookupSources={lookupSources}
                            tabs={tabs}
                            activeTab={activeTab}
                            incrementTempID={incrementTempID}
                        />
					)}
                    {activeHeaderSection === POOL_RIGHT_TYPES_KEY && (
                        <DataGridTable
                            tableContents={rightTypes}
                            changeData={this.changeData.bind(this)}
                            dataGridTableData={dataGridTableData}
                            stateKey={filteredFields[0].name}
                            componentInstance={POOL_RIGHT_TYPES_KEY}
                            showRowNumber={true}
                            isReadOnly={isReadonly}
                            tableActions={[{ name: ADD_NEW_ACTION }]}
                            lookupValues={lookupValues}
                            tabs={tabs}
                            activeTab={activeTab}
                            incrementTempID={incrementTempID}
                        />
					)}
                    {activeHeaderSection === POOL_ALLOCATION_SETTINGS_KEY && (
                        <PoolMaintenanceAllocationSettingsGrid
                            allocationSettingsGridViewData={usagePoolMaintenanceAllocationSettingsGridViewData}
                            isReadonly={isReadonly}
                            poolAllocationSettings={allocationSettings}
                            updateUsagePoolField={updateUsagePoolField}
                            activeTab={activeTab}
                            tabs={tabs}
                            lookupValues={lookupValues}
                        />
					)}
                    {activeHeaderSection === POOL_WEIGHT_SETTINGS_KEY && (
						<div>
							<SizedCheckboxDataInput
								label={'Enable'}
								fieldName={POOL_ENABLED_STATE_KEY}
								value={weightSettingsIsEnabled}
								changeData={this.changeData.bind(this)}
								readonly={isReadonly}
								inline={true}
							/>
							<DatesAndDimensionsWeightingTable
								weightSettingsPoolMaintenanceFields={weightSettingsPoolMaintenance}
								changeData={this.changeData.bind(this)}
								datesAndDimensions={datesAndDimensions}
								saveChanges={saveChanges}
								poolEnabled={weightSettingsIsEnabled}
								handleDeleteAllLinkedWeightsSettingsWhenTheDatesAndDimensionsAreDeleted={this.handleDeleteAllLinkedWeightsSettingsWhenTheDatesAndDimensionsAreDeleted.bind(this)}
								exportUsagePoolWeightMultiplier={exportUsagePoolWeightMultiplier}
								importUsagePoolWeightMultiplier={importUsagePoolWeightMultiplier}
							/>
							<div>
								<PoolMaintenanceWeightSettingsGrid
									weightSettingsGridViewData={usagePoolMaintenanceWeightSettingsGridViewData}
									isReadonly={isReadonly}
									poolAllocationSettings={allocationSettings}
									updateUsagePoolField={updateUsagePoolField}
									activeTab={activeTab}
									tabs={tabs}
									tableContents={weightSettings}
									changeData={this.changeData.bind(this)}
									dataGridTableData={dataGridTableData}
									stateKey={filteredFields[0].name}
									componentInstance={POOL_WEIGHT_SETTINGS_KEY}
									poolEnabled={weightSettingsIsEnabled}
									lookupSources={lookupSources}
									lookupValues={lookupValues}
									incrementTempID={incrementTempID}
									datesAndDimensions={datesAndDimensions}
									sortWeightSettingsFieldData={sortWeightSettingsFieldData}
									isBulkCheckboxActive={isBulkCheckboxActive}
                                    changeBulkCheckbox={changeBulkCheckbox}
                                    allResultsPerPage={allResultsPerPage}
                                    updateUserPreferences={updateUserPreferences}
								/>
							</div>
						</div>
					)}
                    {activeHeaderSection === POOL_WEIGHT_SETTING_CODES_KEY && (
                        <div>
                            <PoolMaintenanceWeightSettingCodesGrid
                                weightSettingCodesMaintenanceFields={usagePoolMaintenanceWeightSettingCodesGridViewData}
                                datesAndDimensions={datesAndDimensions}
								weightSettingCodes={weightSettingCodes}
                                isReadonly={!weightSettingsIsEnabled || datesAndDimensions?.length === 0}
								selectedDimensionAndDateRange={selectedDimensionAndDateRange}
								setSelectedDateRange={this.handleSelectedDimensionAndDateRange.bind(this)}
                                updateUsagePoolField={updateUsagePoolField}
                                exportWeightSettingCodes={exportWeightSettingCodes}
                                importWeightSettingCodes={importWeightSettingCodes}
                            />
                            <PoolWeightCodeMultiplierGrid
								selectedDimensionAndDateRange={selectedDimensionAndDateRange}
                                isReadonly={!selectedDimensionAndDateRange}
								activeTab={activeTab}
								tabs={tabs}
								tableContents={weightCodeMultiplier}
								componentInstance={POOL_WEIGHT_CODE_MULTIPLIER_STATE_KEY}
								dataGridTableData={dataGridTableData}
								incrementTempID={incrementTempID}
								updateUsagePoolField={updateUsagePoolField}
                            />
                        </div>
                    )}
                    {activeHeaderSection === POOL_AMOUNT_MULTIPLIERS_KEY && (
                        <div>
                            <div>
                                <SizedCheckboxDataInput
                                    label={'Enable'}
                                    fieldName={POOL_AMOUNT_MULTIPLIER_ENABLED_STATE_KEY}
                                    value={amountMultipliersIsEnabled}
                                    changeData={this.changeData.bind(this)}
                                    readonly={isReadonly}
                                    inline={true}
                                />
                                <DataGridTable
                                    tableContents={amountMultipliers}
                                    changeData={this.changeData.bind(this)}
                                    dataGridTableData={dataGridTableData}
                                    stateKey={filteredFields[0].name}
                                    componentInstance={POOL_AMOUNT_MULTIPLIERS_KEY}
                                    showRowNumber={true}
                                    isReadOnly={!amountMultipliersIsEnabled}
                                    tableActions={[{ name: ADD_NEW_ACTION, disabled: !amountMultipliersIsEnabled }, { name: REMOVE_ACTION }]}
                                    lookupValues={lookupValues}
                                    lookupSources={lookupSources}
                                    tabs={tabs}
                                    activeTab={activeTab}
                                    incrementTempID={incrementTempID}
                                />
                            </div>
                        </div>
                    )}
                    {activeHeaderSection === POOL_ESTIMATED_VALUE_PER_POINT_SETTINGS_KEY && (
						<div>
							<div>
								<SizedCheckboxDataInput
									label={'Enable'}
									fieldName={POOL_EVPP_ENABLED_STATE_KEY}
									value={evppSettingsIsEnabled}
									changeData={this.changeData.bind(this)}
									readonly={isReadonly}
									inline={true}
								/>
								<PoolMaintenanceEstimatedValuePerPointSettingsGrid
									estimatedValuePerPointSettingsGridViewData={usagePoolMaintenanceEstimatedValuePerPointSettingsGridViewData}
									isReadonly={isReadonly}
									updateUsagePoolField={updateUsagePoolField}
									activeTab={activeTab}
									tabs={tabs}
									tableContents={poolEVPPSettings}
									changeData={this.changeData.bind(this)}
									dataGridTableData={dataGridTableData}
									stateKey={filteredFields[0].name}
									componentInstance={POOL_ESTIMATED_VALUE_PER_POINT_SETTINGS_KEY}
									poolEnabled={evppSettingsIsEnabled}
									lookupSources={lookupSources}
									lookupValues={lookupValues}
									incrementTempID={incrementTempID}
									evppSettingsIsEnabled={evppSettingsIsEnabled}
								/>
							</div>
						</div>
                    )}
                </div>
            </>
        );
    }
}